import Overlay from './overlay';
import toast from './toast';

export function showFlashMessages(response) {
  if (!response || !response.headers) {
    return false;
  }
  let flash = response.headers['x-flash'];

  // Soporte para Fetch Response
  if (!flash && typeof response.headers.get === 'function') {
    flash = response.headers.get('x-flash');
  }
  if (!flash) {
    return false;
  }
  flash = JSON.parse(flash);
  Object.entries(flash).forEach(([key, message]) => {
    // Fix para el encoding del contenido de la cabecera decodeURIComponent
    toastr[key](decodeURIComponent(message));
  });
  return true;
};

/*
{"status":400,"error":{"type":"standard","message":"Error al guardar"},"data":null}
*/
export function showApiErrors(result) {
  // Pueden pasar el objeto result que tiene dentro el response
  // o directamente el response
  const response = result.response || result;
  if (!response.data || !response.data.error) {
    return false;
  }

  toastr.error(response.data.error.message);
  return true;
}

export function showHttpResponseError(response) {
  if (!response || !response.headers) {
    return false;
  }
  if (response.status === 404 || response.status === 500) {
    if (showApiErrors(response)) {
      return true;
    }

    toast.error(
      'Se ha producido un error inesperado. Si el problema persiste póngase en contacto con el soporte técnico de Cifra Educación',
      `Error ${response.status}`,
    );
    return true;
  }
  return false;
}

export function showHttpResponseJsonErrors(response) {
  let texto;
  if (response?.data?.full_messages?.length) {
    texto = response.data.full_messages.join('<br>');
  } else {
    const entries = Object.entries(response?.data?.errors || {});
    if (!entries.length) {
      return false;
    }
    texto = Object.entries(response.data.errors).map(([property, messages]) => (
      messages.map((message) => {
        if (property && property !== 'base') {
          return `${property}: ${message}`;
        }
        return message;
      }).join('<br />')
    )).join('<br />');
  }

  toast.error(texto, 'Error');
  return true;
}

export function showResponseMessages(response) {
  showHttpResponseError(response) || showFlashMessages(response) || showHttpResponseJsonErrors(response)
}

// TODO: Ojo que todavía usa el overlay viejo!!!!!!
export function redirectFromHeaders(response, options) {
  options = Object.assign({ overlay: true }, options);

  var redirect_url = response.headers['x-ajax-redirect-url'];
  if (redirect_url != undefined) {

    var redirigir = function() {
      if (redirect_url.toUpperCase().startsWith("HTTP") || redirect_url.indexOf('?') != -1) {
        window.location = redirect_url;
      } else {
        window.location.pathname = redirect_url;
      }
    }
    if (options.overlay) {
      //Si este setTimeout no me sale el overlay
      setTimeout(function() {
        new Overlay('body').show()
        redirigir();
      }, 100);
    } else {
      redirigir();
    }
  }
}